module.exports = __webpack_public_path__ + "img/Fer2.07490389.webp";